import React from "react";
import { connect } from "react-redux";
import Card from "components/card";
import Notification from "./components/Notification";
import NotificationButton from "./components/NotificationButton";
import AnnouncementBoard from "./components/AnnouncementBoard";
import TimeCard from "./components/TimeCard";
import HyvidPoints from "./components/HyvidPoints";
import SupportCard from "./components/SupportCard";
import WorkClock from "./components/WorkClock";
import MyAttendance from "./components/MyAttendance";
import PerformanceTrend from "./components/PerformanceTrend";
import MyGoals from "./components/MyGoals";
import MyTraining from "./components/MyTraining";
import MyAwards from "./components/MyAwards";

const EmployeeDashBoard = ({auth}) => {
    return (
        <Card className="space-y-6">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                <div>
                    <h1 className="text-[28px] font-bold label-gradient emerald">
                        Welcome back, {auth.user?.display_name}!
                    </h1>
                    <p className="text-[14px] text-slate-700 tracking-normal mt-1">
                        {new Date().toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}
                    </p>
                </div>
                <div>
                    <NotificationButton>
                        <Notification />
                    </NotificationButton>
                </div>
            </div>
            <div>
                <AnnouncementBoard />
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                <TimeCard withClockIn={true}/>
                <HyvidPoints />
                <SupportCard />
            </div>
            <div>
                <WorkClock />
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                <MyAttendance />
                <PerformanceTrend />
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                <MyGoals />
                <MyTraining />
            </div>
            <div>
                <MyAwards />   
            </div>
        </Card>
    )
};
const mapStateToProps = (state) => ({
    auth: state.auth,
    loading: state.auth.loading,
    error: state.auth.error,
});

const mapDispatchToProps = (dispatch) => ({
    
});

export default connect(mapStateToProps, mapDispatchToProps)(EmployeeDashBoard);